import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { useSelector } from "react-redux";
import { selectgroups } from "../redux/businessSlice";
const OrganizationModal = ({ open, onClose, organization }) => {
  // console.log("organization data for detail page", organization);
  const groups = useSelector(selectgroups);

  const groupfilter = (id) => {
    if (!Array.isArray(groups)) {
      return "";
    }
    const data = groups.find((item) => item._id === id.toString());
    return data?.businessNature || "";
  };

  // Early return if organization is not provided or invalid
  if (!open || !organization || typeof organization !== 'object') {
    return null;
  }

  // const getdata = (id) => {
  //   const idString = String(id);
  //   const data1 = allorg.find((item) => String(item.id) === idString);
  //   return data1?.data?.companyName;
  // };

  // console.log("orgination", organization)

  const styles = {
    root: {
      padding: "24px",
    },
    section: {
      marginBottom: "24px",
    },
    card: {
      marginBottom: "16px",
      backgroundColor: "#f5f5f5",
    },
    cardContent: {
      padding: "16px",
    },
    title: {
      fontWeight: "bold",
    },
    subtitle: {
      marginBottom: "8px",
    },
    closeButton: {
      backgroundColor: "#003B93",
      color: "white",
      "&:hover": {
        backgroundColor: "#002a70",
      },
    },
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle style={styles.title}>{organization.companyName}</DialogTitle>
      <DialogContent style={styles.root}>
        {/* Location Card */}
        {organization.location?.name && organization.location?.address && (
          <Card style={styles.card}>
            <CardContent style={styles.cardContent}>
              <Typography variant="h6" style={styles.subtitle}>
                Location
              </Typography>
              <Typography variant="body1">
                <strong>Name:</strong> {organization.location.name}
              </Typography>
              <Typography variant="body1">
                <strong>Address:</strong> {organization?.location?.address}
              </Typography>
            </CardContent>
          </Card>
        )}

        {/* Details Card */}
        {(organization.BusinessGroup ||
          organization.BusinessNature ||
          organization.Incorporationdate ||
          organization.CompanyRegistrationNumber ||
          organization.BusinessRegistrationNumber ||
          organization.TotalPaidUpCapital ||
          organization.ParValueofShares) && (
          <Card style={styles.card}>
            <CardContent style={styles.cardContent}>
              <Typography variant="h6" style={styles.subtitle}>
                Details
              </Typography>
              {organization.BusinessGroup && (
                <Typography variant="body1">
                  <strong>Business Group:</strong>{" "}
                  {groupfilter(organization.BusinessGroup)}
                </Typography>
              )}
              {organization.BusinessNature && (
                <Typography variant="body1">
                  <strong>Business Nature:</strong>{" "}
                  {organization.BusinessNature}
                </Typography>
              )}
              {organization.Incorporationdate && (
                <Typography variant="body1">
                  <strong>Incorporation Date:</strong>{" "}
                  {organization.Incorporationdate}
                </Typography>
              )}
              {organization.CompanyRegistrationNumber && (
                <Typography variant="body1">
                  <strong>Company Registration Number:</strong>{" "}
                  {organization.CompanyRegistrationNumber}
                </Typography>
              )}
              {organization.BusinessRegistrationNumber && (
                <Typography variant="body1">
                  <strong>Business Registration Number:</strong>{" "}
                  {organization.BusinessRegistrationNumber}
                </Typography>
              )}
              {organization.TotalPaidUpCapital && (
                <Typography variant="body1">
                  <strong>Total Paid-Up Capital:</strong> (
                  {organization?.registerCurrency}){" "}
                  {organization.TotalPaidUpCapital.toString().replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )}
                </Typography>
              )}
              {organization.ParValueofShares && (
                <Typography variant="body1">
                  <strong>Par Value of Shares:</strong> ({organization?.ParCurrency}){" "}
                  {organization.ParValueofShares.toString().replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )}
                </Typography>
              )}
            </CardContent>
          </Card>
        )}

        {/* Management Card */}
        {(organization.ManagingDirector ||
          organization.DeputyManagingDirector ||
          organization.Chairman ||
          organization.DeputyChairman ||
          organization.CompanySecretary ||
          organization.RepresentativeDirector ||
          organization.StatutoryAuditor ||
          organization.LegalRepresentative) && (
          <Card style={styles.card}>
            <CardContent style={styles.cardContent}>
              <Typography variant="h6" style={styles.subtitle}>
                Management
              </Typography>
              {organization.Chairman && (
                <Typography variant="body1">
                  <strong>Chairman:</strong> {organization.Chairman}
                </Typography>
              )}
              {organization.DeputyChairman && (
                <Typography variant="body1">
                  <strong>Deputy Chairman:</strong>{" "}
                  {organization.DeputyChairman}
                </Typography>
              )}
              {organization.ManagingDirector && (
                <Typography variant="body1">
                  <strong>Managing Director:</strong>{" "}
                  {organization.ManagingDirector}
                </Typography>
              )}
              {organization.DeputyManagingDirector && (
                <Typography variant="body1">
                  <strong>Deputy Managing Director:</strong>{" "}
                  {organization.DeputyManagingDirector}
                </Typography>
              )}
              {organization.CompanySecretary && (
                <Typography variant="body1">
                  <strong>Company Secretary:</strong>{" "}
                  {organization.CompanySecretary}
                </Typography>
              )}
              {organization.RepresentativeDirector && (
                <Typography variant="body1">
                  <strong>Representative Director:</strong>{" "}
                  {organization.RepresentativeDirector}
                </Typography>
              )}
              {organization.StatutoryAuditor && (
                <Typography variant="body1">
                  <strong>Statutory Auditor:</strong>{" "}
                  {organization.StatutoryAuditor}
                </Typography>
              )}
              {organization.LegalRepresentative && (
                <Typography variant="body1">
                  <strong>Legal Representative:</strong>{" "}
                  {organization.LegalRepresentative}
                </Typography>
              )}
              {organization?.additionalFields?.map((item) => {
                return (
                  <Typography variant="body1">
                    <strong>{item?.fieldName}:</strong> {item?.fieldValue}
                  </Typography>
                );
              })}
            </CardContent>
          </Card>
        )}

        {/* Directors Card */}
        {Array.isArray(organization.directors) &&
          organization.directors.length > 0 && (
            <Card style={styles.card}>
              <CardContent style={styles.cardContent}>
                <Typography variant="h6" style={styles.subtitle}>
                  Directors
                </Typography>
                <Grid container spacing={2}>
                  {organization.directors?.map((director, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Typography variant="body1">
                        <strong>Director {index + 1}:</strong> {director}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          )}

        {/* Shareholders Card */}
        {Array.isArray(organization.shareHolders) &&
          organization.shareHolders.length > 0 && (
            <Card style={styles.card}>
              <CardContent style={styles.cardContent}>
                <Typography variant="h6" style={styles.subtitle}>
                  Shareholders
                </Typography>
                <Grid container spacing={2}>
                  {organization.shareHolders?.map((shareHolder) => (
                    <Grid item xs={12} sm={6} key={shareHolder._id}>
                      <Typography variant="body1">
                        <strong>Name:</strong> {shareHolder?.childName ?? shareHolder?.childId?.companyName}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Number of Shares Owned:</strong>{" "}
                        {shareHolder?.numberSharesOwned
                          ?.toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </Typography>
                      <Typography variant="body1">
                        <strong>Percentage of Shares:</strong>{" "}
                        {shareHolder.PercentageOfShares.toFixed(2)}%
                      </Typography>
                      {shareHolder?.numberofpreferenceshares > 0 && (
                        <Typography variant="body1">
                          <strong>
                            Percentage of Perference Shares Owned:
                          </strong>{" "}
                          {shareHolder?.numberofpreferenceshares}
                        </Typography>
                      )}
                      {shareHolder?.percentageofpreferanceshares > 0 && (
                        <Typography variant="body1">
                          <strong>Percentage of Preference Shares:</strong>{" "}
                          {shareHolder?.percentageofpreferanceshares.toFixed(2)}
                          %
                        </Typography>
                      )}
                    </Grid>
                  ))}
                </Grid> 
              </CardContent>
            </Card>
          )}

        {/* Remarks Card */}
        {organization?.Remarks && (
          <Card style={styles.card}>
            <CardContent style={styles.cardContent}>
              <Typography variant="body1">
                <strong>Remarks:</strong>
                <div
                  dangerouslySetInnerHTML={{ __html: organization.Remarks }}
                />{" "}
                {/* Render HTML content */}
              </Typography>
            </CardContent>
          </Card>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} style={styles.closeButton}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationModal;
